import { useEffect } from 'react';

// Context
import { useAuth } from '@wearetla/tla-essentials-tools/utilities/auth';
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';

const GuestUserController = () => {
	const { isGuestUser } = useAuth();
	const { openModal } = useModals();

	useEffect(() => {
		if (isGuestUser) {
			openModal('guestUser');
		}
	}, [isGuestUser]);

	return null;
};

export default GuestUserController;
